const initialState = {
    payslips:[],
    payroll: [],
    error: null,
    payslipMessage: null,
    isLoding: false
  };
  
  const PaySlipsApiReducer = (state = initialState, action) => {
    switch (action.type) {
      case "LOADING":
        return {
          ...state,
          isLoding: action.payload
        };
  
      case "GET_SALARY_SLIP_SUCCESS":
        return {
          ...state,
          payslipMessage: action.payload,
          error: null
        };
      case "GET_SALARY_SLIP_FAILURE":
        return {
          ...state,
          error: action.payload.error
        };
      
    case "GET_EMPLOYEE_SALARY_SUCCESS":
            return {
              ...state,
              payroll: action.payload,
              error: null
            };
    case "GET_EMPLOYEE_SALARY_FAILURE":
            return {
              ...state,
              error: action.payload.error
            };
      
    case "ADD_PAYROLL_SUCCESS":
                return {
                  ...state,
                  error: null
    };
    case "ADD_PAYROLL_FAILURE":
                return {
                  ...state,
                  error: action.payload.error
    };  

    case "DELETE_PAYROLL_SUCCESS":
      return {
        ...state,
        payroll: action.payload,

        error: null
      };

    case "DELETE_PAYROLL_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "GET_EMPLOYEE_SALARY_SLIP_SUCCESS":
            return {
              ...state,
              payslips: action.payload,
              error: null
            };
    case "GET_EMPLOYEE_SALARY_SLIP_FAILURE":
            return {
              ...state,
              error: action.payload.error
            };

    case "GENRATE_SALARY_REPORT_SUCCESS":
                return {
                  ...state,
                  error: null
    };
    case "GENRATE_SALARY_REPORT_FAILURE":
                return {
                  ...state,
                  error: action.payload.error
    };  
  
      default:
        return state;
    }
  };
  
  export default PaySlipsApiReducer;
  
